import { render } from "./FormButtons.vue?vue&type=template&id=02c2974b"
import script from "./FormButtons.vue?vue&type=script&lang=js"
export * from "./FormButtons.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__